import styled from 'styled-components'
import logo from '../../../../assets/licito-logo.svg'
import menuLateralIcon from '../../../../assets/menuLateralIcon.svg'
import History from './history/history'
import {useContext, useState, useRef, useEffect, useMemo} from 'react'
import HideShowBarButton from '../../../../globalComponents/hideShowBarButton'
import Button from '../../../../globalComponents/ButtonPattern'
import {AuthContext} from '../../../../contexts/auth'
import NavList from './navList'
import {HistoryContext} from '../../../../contexts/history'
import {Badge, Button as MuiButton, IconButton, Tooltip} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import MessageIcon from '../../../../assets/message-text.svg'
import FolderIcon from '../../../../assets/folder-open.svg'
import exitIcon from '../../../../assets/exit.svg'
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined'
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined'
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined'
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined'
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import {getCurrentColors} from '../../../../utils/colors'
import {getCurrentImages} from '../../../../utils/logos'

import {useJwt} from 'react-jwt'
import {CookiesService} from '../../../../services/Cookie.service'

const COLORS = getCurrentColors()
const IMAGES = getCurrentImages()
const LEFTBAR_WIDTH = '248px'

const Section = styled.section<{show: boolean}>`
    width: ${({show}) => (show ? LEFTBAR_WIDTH : '0px')};
    min-width: ${({show}) => (show ? LEFTBAR_WIDTH : '0px')};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 0px 28px 0;
    justify-content: space-between;
    position: relative;
    transform: translateX(${({show}) => (show ? '0' : '-100%')});
    transition: transform 0.3s ease-in-out;
    z-index: 55;
    border-right: 1px solid #e0e0e0;
    @media (max-width: 640px) {
        position: absolute;
        min-height: 100vh;
    }
    overflow-y: auto;
    background-color: #ffffff;
`

const Logo = styled.img`
    width: 168px;
    height: 64px;
    margin-left: 10px;
`
const SeconderyLogo = styled.img`
    width: 115px;
    height: 10px;
    margin-left: 15px;
`

const ListWrapper = styled.div`
    width: 100%;
    display: flex;
    position: relative;
    align-items: flex-start;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
`

const ButtonsContainer = styled.div`
    flex-direction: column;
    width: 100%;
    gap: 8px;
    align-items: flex-start;
`
const CreditsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 214px;
    height: 58px;
    gap: 6px;
    margin-top: 14px;
    margin-left: 14px;
    margin-bottom: 14px;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
`
const CreditsContainerTop = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-left: 12px;
    width: 100%;
`
const CreditsContainerBottom = styled.div<{pathname: string}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 36px;
    border: 1px solid
        ${({pathname}) => {
            return pathname === '/' ? COLORS.secundaria : COLORS.primaria
        }};
    border-radius: 10px;
    margin-left: 16px;
    color: ${({pathname}) => {
        return pathname === '/' ? COLORS.secundaria : COLORS.primaria
    }};
    cursor: pointer;
`

const Credits = styled.div<{pathname: string}>`
    display: flex;
    flex-direction: column;
    min-width: 63px;
    padding: 5px;
    height: 23px;
    height: 23px;
    border-radius: 10px;
    font-size: 14px;
    background-color: ${({pathname}) => {
        return pathname === '/projetos'
            ? COLORS.primariaEscura
            : COLORS.secundariaEscura
    }};
    color: #ffffff;
    align-items: center;
    justify-content: center;
`

interface Props {
    visibility: string
}

const Alert = styled.div<Props>`
    color: ${(props) => props.visibility};
    transition: color 0.25s;
`

interface NavButtonProps {
    tooltip: string
    icon: React.ReactNode
    label: string
    active: boolean
    activeColor?: string
    onClick: () => void
    isNew?: boolean
}

function NavButton({
    tooltip,
    icon,
    label,
    active,
    activeColor = COLORS.primaria,
    onClick,
    isNew,
}: NavButtonProps) {
    const button = (
        <Tooltip title={tooltip} placement="right">
            <MuiButton
                onClick={onClick}
                startIcon={icon}
                aria-current={active ? 'page' : undefined}
                sx={{
                    border: 'none',
                    borderRadius: '14px',
                    justifyContent: 'flex-start',
                    width: '100%',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    color: COLORS.cinzaEscuro,
                    backgroundColor: active ? activeColor : COLORS.branco,
                    padding: '13.2px 13px',
                    gap: '10px',
                    '& .MuiButton-startIcon': {
                        marginRight: 0,
                        marginLeft: 0,
                    },
                    '&:hover': {
                        backgroundColor: active ? activeColor : COLORS.branco,
                        border: 'none',
                    },
                }}
            >
                {label}
            </MuiButton>
        </Tooltip>
    )

    return (
        <div style={{width: '90%', marginLeft: '12px'}}>
            {isNew ? (
                <Badge
                    badgeContent="Novidade"
                    sx={{
                        width: '100%',
                        '& .MuiBadge-badge': {
                            top: '4px',
                            right: '20px',
                            height: 'auto',
                            lineHeight: 1.6,
                            padding: '2px 10px',
                            borderRadius: '47px',
                            fontSize: '9px',
                            fontWeight: 'bold',
                            backgroundColor: '#3ACDB4',
                            color: '#ffffff',
                        },
                    }}
                >
                    {button}
                </Badge>
            ) : (
                button
            )}
        </div>
    )
}

export default function LeftBar() {
    const [show, setShow] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth > 1090
        }
        return true
    })
    const {userInfo, logout} = useContext(AuthContext)
    const {createNewChat, limits, alertVisibility, isChat, setIsChat} =
        useContext(HistoryContext)
    const [openList, setOpenList] = useState(false)
    const listRef = useRef<HTMLDivElement | null>(null)
    const navigate = useNavigate()
    const handleChatsClick = () => {
        setIsChat(true)
        createNewChat()
        navigate('/')
    }
    const handleDocumentosClick = () => {
        setIsChat(false)
        navigate('/projetos')
    }
    const createInitialsSVG = (firstName: string, lastName?: string) => {
        const initials =
            (firstName?.[0] || '').toUpperCase() +
            (lastName?.[0] || '').toUpperCase()
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="30" height="30">
            <circle cx="20" cy="20" r="20" fill="#012441"/>
            <text x="20" y="25" text-anchor="middle" fill="white" font-size="16" font-family="Arial">${initials}</text>
            </svg>`
        return `data:image/svg+xml;base64,${btoa(svg)}`
    }
    const location = useLocation()
    const [logoSrc, setLogoSrc] = useState(logo)
    const cookieService = useMemo(() => new CookiesService(), [])
    const [authToken, setAuthToken] = useState<string>('')

    useEffect(() => {
        const authData = cookieService.getAuthData()
        if (authData?.access_token) {
            setAuthToken(authData.access_token)
        }
    }, [cookieService])

    const {decodedToken} = useJwt(authToken)

    type DecodedAuthToken = {
        sub: string
        name: string
        id: string
        scopes: string[]
        organization: {
            id: string
            name: string
        }
        modules: string[]
        assistants: string[]
        exp: number
        iat: number
    }

    const modules = useMemo(() => {
        if (!decodedToken) return []
        const typedToken = decodedToken as DecodedAuthToken
        return typedToken.modules ?? []
    }, [decodedToken])

    const featureAccess = useMemo(() => {
        const hasModule = (moduleKeys: string | string[]) => {
            if (!modules || modules.length === 0) return false
            const keys = Array.isArray(moduleKeys) ? moduleKeys : [moduleKeys]

            const normalizedKeys = keys.map((key) => key.toLowerCase())

            return modules.some((module) =>
                normalizedKeys.includes(module.toLowerCase())
            )
        }

        return {
            chats: hasModule(['chat']),
            documents: hasModule(['document_generator']),
            analyzer: hasModule(['document_analyzer']),
            priceResearch: hasModule(['price_research']),
            carona: hasModule(['carona_inteligente']),
            // Radar de Fornecedor vive no serviço de pesquisa de preços e usa o mesmo acesso
            // (o backend não exige claim próprio). Trocar p/ 'radar_fornecedor' se o core passar
            // a emitir um módulo dedicado.
            radar: hasModule(['price_research']),
            // Levantamento de Mercado (F1) reusa o claim comercial da Pesquisa de
            // Preços. Trocar p/ 'levantamento_mercado' se o core emitir claim próprio.
            // Gate adicional pela config do ambiente: sem VITE_LEVANTAMENTO_URL no
            // build (ex.: prod antes do deploy do levantamento-service), o item NÃO
            // aparece — evita expor módulo morto a todo org com price_research.
            levantamento:
                hasModule(['price_research']) &&
                !!import.meta.env.VITE_LEVANTAMENTO_URL,
        }
    }, [modules])

    const {
        chats: canAccessChats,
        documents: canAccessDocuments,
        analyzer: canAccessAnalyzer,
        priceResearch: canAccessPriceResearch,
        carona: canAccessCarona,
        radar: canAccessRadar,
        levantamento: canAccessLevantamento,
    } = featureAccess

    const isProcon = window.location.hostname.includes('procon')

    useEffect(() => {
        if (!authToken || modules.length === 0) return
        console.log('Decoded Token Modules:', modules)
    }, [authToken, modules])

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                listRef.current &&
                !listRef.current.contains(event.target as Node)
            ) {
                setOpenList(false)
            }
        }
        if (openList) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [openList])

    const messageCreditsCurrent = limits?.usages?.messages?.current ?? 0
    const messageCreditsMax = limits?.usages?.messages?.max ?? 0
    const projectCreditsCurrent = limits?.usages?.projects?.current ?? 0
    const projectCreditsMax = limits?.usages?.projects?.max ?? 0

    return (
        <>
            <Section show={show}>
                <Wrapper>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0 14px',

                            width: '100%',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                            }}
                        >
                            <Logo src={IMAGES.logo} alt="Logo Schief.ai" />
                        </div>
                        <IconButton
                            onClick={() => setShow((prev) => !prev)}
                            aria-label={
                                show ? 'Fechar menu lateral' : 'Abrir menu lateral'
                            }
                            aria-expanded={show}
                            size="small"
                        >
                            <img
                                src={menuLateralIcon}
                                alt=""
                                style={{width: '24px', height: '24px'}}
                            />
                        </IconButton>
                    </div>

                    {(canAccessChats ||
                        canAccessDocuments ||
                        canAccessAnalyzer ||
                        canAccessPriceResearch ||
                        canAccessCarona ||
                        canAccessRadar ||
                        canAccessLevantamento) && (
                        <>
                            {canAccessChats && (
                                <NavButton
                                    tooltip="Criar nova consulta"
                                    label="Consultas"
                                    icon={
                                        <img
                                            src={MessageIcon}
                                            alt=""
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                            }}
                                        />
                                    }
                                    active={location.pathname === '/'}
                                    activeColor={COLORS.secundaria}
                                    onClick={handleChatsClick}
                                />
                            )}

                            {canAccessDocuments && !isProcon && (
                                <NavButton
                                    tooltip="Documentos"
                                    label="Documentos"
                                    icon={
                                        <img
                                            src={FolderIcon}
                                            alt=""
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                filter: 'brightness(0)',
                                            }}
                                        />
                                    }
                                    active={location.pathname === '/projetos'}
                                    onClick={handleDocumentosClick}
                                />
                            )}

                            {canAccessAnalyzer && !isProcon && (
                                <NavButton
                                    tooltip="Analisar documentos"
                                    label="Análise de Documentos"
                                    icon={
                                        <FindInPageOutlinedIcon
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                            }}
                                        />
                                    }
                                    active={
                                        location.pathname === '/analisador'
                                    }
                                    onClick={() => navigate('/analisador')}
                                />
                            )}

                            {canAccessPriceResearch && (
                                <NavButton
                                    tooltip="Pesquisa de Preços"
                                    label="Pesquisa de Preços"
                                    icon={
                                        <RequestQuoteOutlinedIcon
                                            sx={{
                                                width: '20px',
                                                height: '20px',
                                                color: COLORS.cinzaEscuro,
                                            }}
                                        />
                                    }
                                    active={
                                        location.pathname === '/pesquisa-precos'
                                    }
                                    onClick={() => navigate('/pesquisa-precos')}
                                    isNew
                                />
                            )}

                            {canAccessLevantamento && (
                                <NavButton
                                    tooltip="Levantamento de Mercado"
                                    label="Levantamento de Mercado"
                                    icon={
                                        <TravelExploreOutlinedIcon
                                            sx={{
                                                width: '20px',
                                                height: '20px',
                                                color: COLORS.cinzaEscuro,
                                            }}
                                        />
                                    }
                                    active={
                                        location.pathname ===
                                        '/levantamento-mercado'
                                    }
                                    onClick={() =>
                                        navigate('/levantamento-mercado')
                                    }
                                    isNew
                                />
                            )}

                            {canAccessRadar && (
                                <NavButton
                                    tooltip="Radar de Fornecedor"
                                    label="Radar de Fornecedor"
                                    icon={
                                        <PersonSearchOutlinedIcon
                                            sx={{
                                                width: '20px',
                                                height: '20px',
                                                color: COLORS.cinzaEscuro,
                                            }}
                                        />
                                    }
                                    active={
                                        location.pathname ===
                                        '/radar-fornecedor'
                                    }
                                    onClick={() =>
                                        navigate('/radar-fornecedor')
                                    }
                                    isNew
                                />
                            )}

                            {canAccessCarona && (
                                <NavButton
                                    tooltip="Ata Inteligente"
                                    label="Ata Inteligente"
                                    icon={
                                        <HandshakeOutlinedIcon
                                            sx={{
                                                width: '20px',
                                                height: '20px',
                                                color: COLORS.cinzaEscuro,
                                            }}
                                        />
                                    }
                                    active={location.pathname === '/carona'}
                                    onClick={() => navigate('/carona')}
                                    isNew
                                />
                            )}
                        </>
                    )}

                    <NavButton
                        tooltip="Suporte"
                        label="Suporte"
                        icon={
                            <SupportAgentIcon
                                sx={{
                                    width: '20px',
                                    height: '20px',
                                    color: COLORS.cinzaEscuro,
                                }}
                            />
                        }
                        active={location.pathname === '/suporte'}
                        onClick={() => navigate('/suporte')}
                    />
                    {/* {alertVisibility === 'red' && (
                        <Alert visibility={alertVisibility}>
                            Você já está em um novo chat!
                        </Alert>
                    )} */}
                    {isChat && location.pathname === '/' ? (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                            }}
                        >
                            <History />
                            {location.pathname === '/' && !isProcon && (
                                <IconButton
                                    onClick={() => handleChatsClick()}
                                    aria-label="Criar nova consulta"
                                    size="small"
                                    style={{
                                        marginRight: '4px',
                                        marginTop: '2px',
                                    }}
                                >
                                    <AddCommentOutlinedIcon
                                        fontSize="medium"
                                        style={{
                                            color: COLORS.secundariaEscura,
                                        }}
                                    />
                                </IconButton>
                            )}
                        </div>
                    ) : null}
                </Wrapper>

                <ListWrapper ref={listRef}>
                    {openList && <NavList />}
                    <ButtonsContainer>
                        <CreditsContainer>
                            <CreditsContainerTop>
                                <Credits pathname={location.pathname}>
                                    {location.pathname === '/projetos'
                                        ? 'DOCUMENTOS'
                                        : 'CONSULTAS'}
                                </Credits>
                                <span
                                    style={{color: '#ABABAB', fontSize: '12px'}}
                                >
                                    {location.pathname === '/projetos'
                                        ? `${projectCreditsCurrent}/${projectCreditsMax} `
                                        : `${messageCreditsCurrent}/${messageCreditsMax} `}
                                    Créditos
                                </span>
                            </CreditsContainerTop>
                        </CreditsContainer>
                        <Button
                            onclick={() => setOpenList((prev) => !prev)}
                            IconAltText="Abrir Lista de Configurações"
                            text={`${userInfo.first_name}`}
                            SVGIcon={createInitialsSVG(
                                userInfo.first_name,
                                userInfo.last_name
                            )}
                            align="left"
                            // endText={`${limits.current_answers}/${limits.max_answers}`}
                            tooltip="Conta"
                            customStyle={{
                                border: 'none',
                                padding: '8px 16px',
                                background: 'transparent',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '90%',
                                justifyContent: 'flex-start',
                                paddingLeft: '20px',
                            }}
                        />
                        <Button
                            onclick={logout}
                            IconAltText="sair"
                            text="Sair"
                            SVGIcon={exitIcon}
                            align="left"
                            customStyle={{
                                border: 'none',
                                padding: '8px 16px',
                                background: 'transparent',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '90%',
                                justifyContent: 'flex-start',
                                paddingLeft: '20px',
                            }}
                        />
                    </ButtonsContainer>
                </ListWrapper>
            </Section>
            <HideShowBarButton
                position="left"
                offset={show ? LEFTBAR_WIDTH : '0px'}
                show={show}
                setShow={setShow}
            />
        </>
    )
}
